import { IJobs } from './jobs';
import { IContainer, injectContainer } from '../../interface/container';

const TYPES = {
    IJobs: Symbol.for('IJobs'),
};

export function injectJobs(container: IContainer = injectContainer()): IJobs {
    return container.get<IJobs>(TYPES.IJobs);
}

export function bindJobs(val: IJobs, container: IContainer = injectContainer()) {
    return container.bind<IJobs>(TYPES.IJobs, val);
}

export function unbindJobs(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IJobs);
}
